import { type } from '@app/store/util';
import { Action } from '@ngrx/store';

/** @deprecated this is moved to libs */
export const ANALYTICS_PRODUCT_VIEW = type('[Analytics] Product view');
/** @deprecated this is moved to libs */
export const ANALYTICS_CAR_CALCULATION = type('[Analytics] Car Calculation');
/** @deprecated this is moved to libs */
export const ANALYTICS_BICYCLE_CALCULATION = type('[Analytics] Bicycle Calculation');
/** @deprecated this is moved to libs */
export const ANALYTICS_CARAVAN_CALCULATION = type('[Analytics] Caravan Calculation');
/** @deprecated this is moved to libs */
export const ANALYTICS_MOPED_CALCULATION = type('[Analytics] Moped Calculation');
/** @deprecated this is moved to libs */
export const ANALYTICS_MOTOR_CALCULATION = type('[Analytics] Motor Calculation');
/** @deprecated this is moved to libs */
export const ANALYTICS_HOME_CALCULATION = type('[Analytics] Home Calculation');
/** @deprecated this is moved to libs */
export const ANALYTICS_TRAVEL_CALCULATION = type('[Analytics] Travel Calculation');
/** @deprecated this is moved to libs */
export const ANALYTICS_PET_CALCULATION = type('[Analytics] Pet Calculation');
/** @deprecated this is moved to libs */
export const ANALYTICS_CHECKOUT = type('[Analytics] Checkout');
/** @deprecated this is moved to libs */
export const ANALYTICS_CHECKOUT_OPTION = type('[Analytics] Checkout Option');
/** @deprecated this is moved to libs */
export const ANALYTICS_CHANGED_CART = type('[Analytics] Changed Cart');
/** @deprecated this is moved to libs */
export const ANALYTICS_PURCHASE = type('[Analytics] Purchase');
/** @deprecated this is moved to libs */
export const ANALYTICS_VIEW_ITEM = type('[Analytics] View Item');
/** @deprecated this is moved to libs */
export const ANALYTICS_VIEW_CART = type('[Analytics] View Cart');

/** @deprecated this is moved to libs */
export class AnalyticsProductView implements Action {
    readonly type = ANALYTICS_PRODUCT_VIEW;
    constructor(public payload?: any) { }
}

/** @deprecated this is moved to libs */
export class AnalyticsCarCalculation implements Action {
    readonly type = ANALYTICS_CAR_CALCULATION;
    constructor(public payload?: any) { }
}

/** @deprecated this is moved to libs */
export class AnalyticsMopedCalculation implements Action {
    readonly type = ANALYTICS_MOPED_CALCULATION;
    constructor(public payload?: any) { }
}

/** @deprecated this is moved to libs */
export class AnalyticsMotorCalculation implements Action {
    readonly type = ANALYTICS_MOTOR_CALCULATION;
    constructor(public payload?: any) { }
}

/** @deprecated this is moved to libs */
export class AnalyticsBicycleCalculation implements Action {
    readonly type = ANALYTICS_BICYCLE_CALCULATION;
    constructor(public payload?: any) { }
}

/** @deprecated this is moved to libs */
export class AnalyticsCaravanCalculation implements Action {
    readonly type = ANALYTICS_CARAVAN_CALCULATION;
    constructor(public payload?: any) { }
}

/** @deprecated this is moved to libs */
export class AnalyticsTravelCalculation implements Action {
    readonly type = ANALYTICS_TRAVEL_CALCULATION;
}

/** @deprecated this is moved to libs */
export class AnalyticsHomeCalculation implements Action {
    readonly type = ANALYTICS_HOME_CALCULATION;
    constructor(public payload?: any) { }
}

/** @deprecated this is moved to libs */
export class AnalyticsPetCalculation implements Action {
    readonly type = ANALYTICS_PET_CALCULATION;
}

/** @deprecated this is moved to libs */
export class AnalyticsCheckout implements Action {
    readonly type = ANALYTICS_CHECKOUT;
    constructor(public payload?: any) { }
}

/** @deprecated this is moved to libs */
export class AnalyticsCheckoutOption implements Action {
    readonly type = ANALYTICS_CHECKOUT_OPTION;
    constructor(public payload?: any) { }
}

/** @deprecated this is moved to libs */
export class AnalyticsChangedCart implements Action {
    readonly type = ANALYTICS_CHANGED_CART;
    constructor(public payload?: any) { }
}

/** @deprecated this is moved to libs */
export class AnalyticsPurchase implements Action {
    readonly type = ANALYTICS_PURCHASE;
    constructor(public payload?: any) { }
}

/** @deprecated this is moved to libs */
export class AnalyticsViewItem implements Action {
    readonly type = ANALYTICS_VIEW_ITEM;
    constructor(public payload?: any) { }
}

/** @deprecated this is moved to libs */
export class AnalyticsViewCart implements Action {
    readonly type = ANALYTICS_VIEW_CART;
    constructor(public payload?: any) { }
}

/** @deprecated this is moved to libs */
export type Actions
    = AnalyticsProductView
    | AnalyticsCarCalculation
    | AnalyticsHomeCalculation
    | AnalyticsCheckout
    | AnalyticsCheckoutOption
    | AnalyticsChangedCart
    | AnalyticsPurchase
    | AnalyticsBicycleCalculation
    | AnalyticsCaravanCalculation
    | AnalyticsMopedCalculation
    | AnalyticsMotorCalculation
    | AnalyticsTravelCalculation
    | AnalyticsPetCalculation
    | AnalyticsViewItem
    | AnalyticsViewCart;
